import React from 'react';
import { StaticPage, TopbarContainer } from '..';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import SectionHeader from './SectionHeader'
import {Grid} from '@material-ui/core'
import { FormattedMessage } from '../../util/reactIntl';


// Image 
import CusStep1 from '../../assets/customer/step1.png'
import CusStep2 from '../../assets/customer/step2.png'
import CusStep3 from '../../assets/customer/step3.png'
import CusStep4 from '../../assets/customer/step4.png'

import ProStep1 from '../../assets/provider/step1.png'
import ProStep2 from '../../assets/provider/step2.png'
import ProStep3 from '../../assets/provider/step3.png'
import ProStep4 from '../../assets/provider/step4.png'


import css from './HowItWorkPage.module.css';

const HowItWorkPage = () => {

  const [current, setCurrent] = React.useState("provider");


  // prettier-ignore
  return (
    <StaticPage
        title="Comment ça marche ?"
        schema={{
        "@context": "http://schema.org",
        "@type": "HowItWorkPage",
        "description": "Comment ça marche ?",
        "name": "Comment ça marche ?"
        }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.mainWrapper}>
          <SectionHeader 
          current={current}
          onChange={setCurrent}
          />
          <div className={css.content}>
            <Grid container  spacing={0}>
              <Grid item xs={12} sm={4} className={css.spacing}>
                <div className={css.imgWrapper}>
                  <img src={ current === 'provider' ? ProStep1 :  CusStep1} alt="step1" />
                </div>
              </Grid>
              <Grid item xs={12} sm={8} className={css.spacing}>
                <h2><FormattedMessage id={`HowItWorkPage.${current}StepTitle1`} /></h2>
                <p><FormattedMessage id={`HowItWorkPage.${current}StepText1`} /></p>
              </Grid>
              <Grid item xs={12} sm={4} className={css.spacing}>
                <div className={css.imgWrapper}>
                  <img src={ current === 'provider' ? ProStep2 :  CusStep2} alt="step2" />
                </div>
              </Grid>
              <Grid item xs={12} sm={8} className={css.spacing}>
                <h2><FormattedMessage id={`HowItWorkPage.${current}StepTitle2`} /></h2>
                <p><FormattedMessage id={`HowItWorkPage.${current}StepText2`} /></p>
              </Grid>
              <Grid item xs={12} sm={4} className={css.spacing}>
                <div className={css.imgWrapper} >
                  <img src={ current === 'provider' ? ProStep3 :  CusStep3} alt="step3" />
                </div>
              </Grid>
              <Grid item xs={12} sm={8} className={css.spacing}>
                <h2><FormattedMessage id={`HowItWorkPage.${current}StepTitle3`} /></h2>
                <p><FormattedMessage id={`HowItWorkPage.${current}StepText3`} /></p>
              </Grid>
              <Grid item xs={12} sm={4} className={css.spacing}>
                <div className={css.imgWrapper} >
                  <img src={ current === 'provider' ? ProStep4 :  CusStep4} alt="step4" />
                </div>
              </Grid> 
              <Grid item xs={12} sm={8} className={css.spacing}>
                <h2><FormattedMessage id={`HowItWorkPage.${current}StepTitle4`} /></h2>
                <p><FormattedMessage id={`HowItWorkPage.${current}StepText4`} /></p>
              </Grid>
            </Grid>
          </div>
          
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default HowItWorkPage;